import { Text } from 'tamagui'
import { useApp } from '../../i18n'
import type { Employment, EmploymentRequisite } from '../../lib/types'

type Translate = ReturnType<typeof useApp>['t']
const missing = { ru: 'Не указано', az: 'Göstərilməyib', en: 'Not specified' }

function requisiteValue(value: EmploymentRequisite, t: Translate, unnamed?: string): string {
  switch (value.state) {
    case 'present': return value.label?.trim() || unnamed || t(missing)
    case 'stale': return `${value.label?.trim() || t(missing)} · ${t({ ru: 'Устарело', az: 'Köhnəlib', en: 'Outdated' })}`
    case 'reference_unresolved': {
      const unconfirmed = t({ ru: 'Не подтверждено', az: 'Təsdiqlənməyib', en: 'Unconfirmed' })
      return value.label?.trim() ? `${value.label.trim()} · ${unconfirmed}` : unconfirmed
    }
    case 'unavailable': return t({ ru: 'Не удалось загрузить', az: 'Yükləmək mümkün olmadı', en: 'Could not load' })
    case 'conflict': return t({ ru: 'Противоречивые данные', az: 'Ziddiyyətli məlumatlar', en: 'Conflicting data' })
    case 'invalid': return t({ ru: 'Некорректные данные', az: 'Yanlış məlumatlar', en: 'Invalid data' })
    case 'unsupported': return t({ ru: 'Недоступно для этого источника', az: 'Bu mənbə üçün mövcud deyil', en: 'Not available for this source' })
    case 'missing': return t(missing)
  }
}

export function employmentTypeText(job: Employment, t: Translate): string {
  // The portal primary badge is independent of the source employment type.
  if (job.employmentTypeState && job.employmentTypeState !== 'present') {
    return requisiteValue({ state: job.employmentTypeState, label: job.employmentTypeLabel ?? null }, t)
  }
  if (!job.employmentType) return t(missing)
  if (job.employmentType === 'Совместительство') return t({ ru: 'Совместительство', az: 'Əvəzçilik', en: 'Secondary employment' })
  if (job.employmentType === 'ОсновноеМестоРаботы') return t({ ru: 'Основная работа', az: 'Əsas iş', en: 'Main employment' })
  return job.employmentTypeLabel?.trim() || t({ ru: 'Другая занятость', az: 'Digər məşğulluq', en: 'Other employment' })
}

export function EmploymentRequisites({ job }: { job: Employment }) {
  const { t } = useApp()
  return <>
    {job.departmentType && <Text fontSize={11} color="$muted">{`${t({ ru: 'Тип подразделения (1С)', az: 'Bölmə növü (1C)', en: 'Department type (1C)' })}: ${requisiteValue(job.departmentType, t)}`}</Text>}
    {job.positionSchedule && <Text fontSize={11} color="$muted">{`${t({ ru: 'График позиции по ШР', az: 'Ştat cədvəli üzrə vəzifə qrafiki', en: 'Position schedule from staffing table' })}: ${requisiteValue(job.positionSchedule, t, t({ ru: 'График указан; название недоступно', az: 'Qrafik göstərilib; adı mövcud deyil', en: 'Schedule specified; name unavailable' }))}`}</Text>}
  </>
}
